<script lang="ts">
	import { createEventDispatcher, onMount } from "svelte";

	let clazz: string = "";
	export { clazz as class };
	export let value: string | number | null = "";
	export let placeholder: string = "";
	export let debounce = 0;
	export let type: string = "";
	export let borderless = false;
	export let ref: HTMLElement | null = null;
	export let error: boolean = false;
	export let warning: boolean = false;
	export let disabled: boolean = false;
	export let focused: boolean = false;
	export let name = "";
	export let required = false;
	export let minLength: number | null = null;

	let timer: any;

	const dispatch = createEventDispatcher();

	const debounceFc = (e: any) => {
		clearTimeout(timer);

		timer = setTimeout(() => {
			handleInput(e);
		}, debounce);
	};

	const handleInput = (e: any) => {
		// in here, you can switch on type and implement
		// whatever behaviour you need
		value = type.match(/^(number|range)$/) ? +e.target.value : e.target.value;
		dispatch("input", value);
	};

	let ref_: HTMLElement;
	onMount(() => {
		ref = ref_;
	});
</script>

<div
	class="
    relative flex w-full rounded-lg bg-gray-100 text-black transition-colors placeholder:text-slate-400 {clazz} 
	{error &&
		' group-data-[focused=true]/input:!border-red-600 group-data-[error=true]/input:!text-red-400 group-data-[focused=true]/input:!text-red-600'}
			{warning &&
		'group-data-[focused=true]/input:!border-yellow-600 group-data-[focused=true]/input:!text-yellow-600 group-data-[warning=true]/input:!text-yellow-400'}
    group-data-[focused=true]/input:border-secondary
    group-data-[focused=true]/input:!text-black
    {!borderless && 'order-current p-1'} 
	
	"
>
	<slot name="before" />
	<input
		on:invalid
		on:click
		on:blur
		on:blur={(event) => {
			focused = false;
		}}
		on:focus
		on:focus={() => {
			focused = true;
		}}
		on:input={debounceFc}
		on:change
		on:keydown
		{disabled}
		bind:this={ref_}
		{placeholder}
		aria-label="input"
		{type}
		{value}
		{name}
		{required}
		minlength={minLength}
		class="block w-full min-w-16 bg-transparent pl-2 outline-none
	 "
		{...$$restProps}
	/>
	<slot name="after" />
</div>
